import { render, staticRenderFns } from "./LogoSkeleton.vue?vue&type=template&id=285483a0&"
import script from "./LogoSkeleton.vue?vue&type=script&lang=js&"
export * from "./LogoSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports